import { Outlet, createRootRoute } from '@tanstack/react-router';
import { AppErrorFallback } from '~/components/errors';
import { ContextMenuSurface } from '~/components/primitives/ContextMenu';

export const Route = createRootRoute({
  component: RootLayout,
  // F6 — fallback для runtime exceptions в любой route (ZodError parse, throw и т.д.).
  errorComponent: ({ error, reset }) => <AppErrorFallback error={error} reset={reset} />,
});

function RootLayout(): JSX.Element {
  return (
    <>
      <Outlet />
      {/* Пак context-menu, F1 — единственный носитель ПКМ-меню на приложение
          (SOLUTION §6): второй ПКМ обязан закрыть первый, где бы тот ни жил. */}
      <ContextMenuSurface />
    </>
  );
}
